import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import useHistoryPathPush from 'client/hooks/useHistoryPathPush';

const protectedRoutes = ['/form', '/result', '/prize'];

export default function useUgcRoutesProtect() {
    const { promoId } = useParams();
    const location = useLocation();
    const history = useHistoryPathPush();
    const { hasInited } = useSelector(s => s.flags);

    useEffect(() => {
        if (!hasInited) {
            if (protectedRoutes.some(p => location.pathname.includes(p))) {
                history.push({ pathname: `/${promoId}` });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasInited]);
}
